// ** React Imports
import { useEffect } from "react"
// import { NavLink } from "react-router-dom"
import { NavItem, NavLink } from "reactstrap"
// ** Icons Imports
import { Disc, X, Circle, Menu } from "react-feather"
import {
  handleMenuCollapsed
} from "../../../../../redux/layout"
// ** Config
import themeConfig from "../../../../../configs/themeConfig"
// ** Store & Actions
import { useDispatch } from "react-redux"
// ** Utils
// import { getUserData } from "@utils"

const VerticalMenuHeader = (props) => {
  // ** Props
  const {
    menuCollapsed,
    setMenuCollapsed,
    // setMenuVisibility,
    setGroupOpen,
    menuHover
  } = props

  // ** Vars
  const dispatch = useDispatch()
  // const user = getUserData()

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  // ** Menu toggler component
  const Toggler = () => {
    if (!menuCollapsed) {
      return (
        <Disc
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(true)}
        />
      )
    } else {
      return (
        <Circle
          size={20}
          data-tour="toggle-icon"
          className="text-primary toggle-icon d-none d-xl-block"
          onClick={() => setMenuCollapsed(false)}
        />
      )
    }
  }
  const trueBool = true
  return (
    <div className="navbar-header d-flex p-1 mb-2 d-none">
      <ul className="nav navbar-nav">
        <li className="nav-item mt-1 me-1 mx-1">
          <NavLink
            className="nav-menu-main menu-toggle hidden-xs is-active p-0"
            onClick={() => {
              // setMenuVisibility(false)
              dispatch(handleMenuCollapsed(menuCollapsed ? false : trueBool))
            }}
          >
            <Menu className="ficon" />
          </NavLink>
        </li>
        <li className="nav-item mt-1">
          <NavLink
            className="navbar-brand"
            style={{ marginTop: '-8px' }}
          >
            <span className="brand-logo">
              <img src={themeConfig.app.appLogoImage} alt="logo" style={{ maxWidth: '200px' }} />
            </span>
          </NavLink>
        </li>
      </ul>

      {/* <ul className="nav navbar-nav flex-row d-none">
        <li className="nav-item me-auto">
          <NavLink
            to="/"
            className="navbar-brand"
          >
            <span className="brand-logo">
              <img src={themeConfig.app.appLogoImage} alt="logo" />
            </span>
            <h2 className="brand-text mb-0">{themeConfig.app.appName}</h2>
          </NavLink>
        </li>
        <li className="nav-item nav-toggle">
          <div className="nav-link modern-nav-toggle cursor-pointer">
            <Toggler />
            <X
              onClick={() => setMenuVisibility(false)}
              className="toggle-icon icon-x d-block"
              size={20}
            />
          </div>
        </li>
      </ul> */}
    </div>
  )
}

export default VerticalMenuHeader
